
import axios from "axios";
import {apiUrl} from '../AxiosAPI' ;  

  
export const loginLeadManager= (crmData) => axios.post(`${apiUrl}/loginLeadManager`,crmData);  
 

export const checkLeadManagerLoginStatus= (crmData) => axios.post(`${apiUrl}/checkLeadManagerLoginStatus`,crmData);  
export const createALeadByManager= (crmData) => axios.post(`${apiUrl}/createALeadByManager`,crmData);  
 
export const getLeadsBySearchParameter= (crmData) => axios.post(`${apiUrl}/getLeadsBySearchParameter`,crmData);  
 

